import axios from "axios";

// Créer l'instance Axios avec baseURL
const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

// ✅ INTERCEPTEUR REQUEST : Ajouter automatiquement le token à chaque requête
instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
            // console.log('🔑 Token ajouté à la requête');
        }
        
        return config;
    },
    (error) => {
        console.error('❌ Erreur intercepteur request:', error);
        return Promise.reject(error);
    }
);

// ✅ INTERCEPTEUR RESPONSE : Gérer les erreurs d'authentification
instance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Si erreur 401, rediriger vers la page de connexion appropriée
        if (error.response?.status === 401) {
            console.error('🚫 Non authentifié - Nettoyage du localStorage');
            
            const role = localStorage.getItem('role');
            localStorage.clear();
            
            // Rediriger selon le rôle
            if (role === 'SECRETARY') {
                window.location.href = '/secretary-login';
            } else {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default instance;